import * as api from "Api";

class NotificationApi {
  getNotificationDashboard(userId, uen) {
    return api.getNotificationDashboard({
      userId: userId,
      uen: uen
    });
  }
  getNotificationSlide(userId, uen) {
    return api.getNotificationSlide({
      userId: userId,
      uen: uen
    });
  }
  closeNotification(userId, uen, action) {
    return api.closeNotification({
      userId: userId,
      uen: uen,
      action: action
    });
  }
  getNotificationDashboardCrossSharing(userId, uen) {
    return api.getNotificationDashboardCrossSharing({
      userId: userId,
      uen: uen
    });
  }
  getNotificationSlideCrossSharing(userId, uen) {
    return api.getNotificationSlideCrossSharing({
      userId: userId,
      uen: uen
    });
  }
  getNotificationBalanceImported(userId, uen) {
    return api.getNotificationBalanceImported({
      userId: userId,
      uen: uen
    });
  }
}
export default new NotificationApi();



// WEBPACK FOOTER //
// ./src/services/NotificationServices.js